import {
  ListOrgGrsRequest,
  ListOrgGrsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

type ListOrgGrsParams = {
  orgId: string;
};

export const listOrgGrs = async (
  { orgId }: ListOrgGrsParams,
  headers: Record<RequestMetadata, string>
): Promise<ListOrgGrsResponse> => {
  const req = new ListOrgGrsRequest({
    orgId,
  });

  return supportServiceConnectClient.listOrgGrs(req, { headers });
};
